import HiddenAmount from './HiddenAmount'

export default HiddenAmount
